// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1U2kM","calendarButtons":"ClockData_calendarButtons__1za2a"};